import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './shared/Logo';
const NAV = [{
  label: 'Početna',
  href: '#pocetna'
}, {
  label: 'O nama',
  href: '#o-nama'
}, {
  label: 'Usluge',
  href: '#usluge'
}, {
  label: 'Zašto mi',
  href: '#zasto-mi'
}, {
  label: 'Galerija',
  href: '#galerija'
}, {
  label: 'Česta pitanja',
  href: '#pitanja'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  const handleNav = (href: string) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'glass shadow-luxury py-3' : 'bg-transparent py-5'}`} data-id="element-161">
      <nav aria-label="Glavna navigacija" className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-162">
        <a href="#pocetna" onClick={e => {
        e.preventDefault();
        handleNav('#pocetna');
      }} aria-label="Golden Care — početna" data-id="element-163">
          <Logo size={scrolled ? 44 : 48} variant="md" data-id="element-164" />
        </a>

        <ul className="hidden items-center gap-7 lg:flex" data-id="element-165">
          {NAV.map(item => <li key={item.href} data-id="element-166">
              <a href={item.href} onClick={e => {
            e.preventDefault();
            handleNav(item.href);
          }} className="group relative text-sm font-medium text-ink/80 transition-colors hover:text-gold-dark" data-id="element-167">
                {item.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" data-id="element-168" />
              </a>
            </li>)}
        </ul>

        <div className="flex items-center gap-3" data-id="element-169">
          <a href="#kontakt" onClick={e => {
          e.preventDefault();
          handleNav('#kontakt');
        }} className="hidden items-center gap-2 rounded-full bg-gold-gradient px-6 py-3 text-sm font-semibold text-white shadow-gold transition-transform hover:scale-[1.03] active:scale-95 sm:inline-flex" data-id="element-170">
            <PhoneIcon className="h-4 w-4" data-id="element-171" />
            Kontaktirajte nas
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Zatvori meni' : 'Otvori meni'} aria-expanded={open} className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-ink transition-colors hover:bg-cream lg:hidden" data-id="element-172">
            {open ? <XIcon className="h-5 w-5" data-id="element-173" /> : <MenuIcon className="h-5 w-5" data-id="element-174" />}
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-175">
        {open && <motion.div initial={{
        opacity: 0,
        y: -12
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -12
      }} transition={{
        duration: 0.25
      }} className="glass mx-4 mt-3 overflow-hidden rounded-2xl shadow-luxury lg:hidden" data-id="element-176">
            <ul className="flex flex-col p-4" data-id="element-177">
              {NAV.map(item => <li key={item.href} data-id="element-178">
                  <a href={item.href} onClick={e => {
              e.preventDefault();
              handleNav(item.href);
            }} className="block rounded-xl px-4 py-3 text-base font-medium text-ink transition-colors hover:bg-cream hover:text-gold-dark" data-id="element-179">
                    {item.label}
                  </a>
                </li>)}
              <li className="mt-2 px-2" data-id="element-180">
                <a href="#kontakt" onClick={e => {
              e.preventDefault();
              handleNav('#kontakt');
            }} className="flex items-center justify-center gap-2 rounded-full bg-gold-gradient px-6 py-3.5 text-sm font-semibold text-white shadow-gold" data-id="element-181">
                  <PhoneIcon className="h-4 w-4" data-id="element-182" />
                  Kontaktirajte nas
                </a>
              </li>
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}